export default __webpack_public_path__ + "static/media/avatar.e0fce09c.png";